import React, { Component, Fragment } from 'react';
import { ForgeIcon, ForgeListItem, ForgeTooltip } from '@tylertech/forge-react';

interface ICustomizationTabProps {
  id: string;
  title: string;
  icon: string;
  selected?: boolean;
  onTabNavigation: (tabId: string) => void;
}

class AuthoringWorkflowTab extends Component<ICustomizationTabProps> {
  tooltipAttributes = () => {
    const { id } = this.props;

    return {
      anchor: id,
      delay: 500,
      position: 'right',
    };
  };

  listItemAttributes = () => {
    const { id, selected, title, onTabNavigation } = this.props;
    return {
      id: id,
      indented: false,
      'aria-label': title,
      'aria-controls': `${id}-panel`,
      className: `panel-btn ${id}-panel-btn`,
      selected,
      onClick: onTabNavigation.bind(this, id),
    };
  };

  render() {
    const { id, icon, title } = this.props;

    return (
      <Fragment key={id}>
        <ForgeListItem {...this.listItemAttributes()}>
          <ForgeIcon slot="start" name={icon} />
        </ForgeListItem>
        <ForgeTooltip {...this.tooltipAttributes()}>{title}</ForgeTooltip>
      </Fragment>
    );
  }
}

export default AuthoringWorkflowTab;
